import { t } from '../i18n';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorMessageType, ErrorCouponType, PageTypeEnum } from '../types';
import { KeyValuePair } from '@teko/ui';
import fnsFormat from 'date-fns/format';
import { CustomCategoryProps } from '@teko/ecommerce/mobile';
import { LinkProps } from 'next/link';
import slug from '@teko/slug';
import { NextRouter } from 'next/router';
import { buildSlugUrl } from '../helpers';
import { DiscoveryBlock, DiscoveryItem } from '@teko/discovery';
import { LinkInterface } from '@teko/types/ds';
export {
  getObjFromQueryString,
  isValidEmailFormat,
  isValidPhoneFormat,
} from '@teko/utils';
import { MenuItem } from '@teko/discovery';
declare global {
  interface Window {
    MSStream: any;
  }
}
export const cleanObject = (object: any): any => {
  const newObj: any = {};
  Object.keys(object).forEach((key) => {
    if (object[key] || object[key] === false || object[key] === 0) {
      newObj[key] = object[key];
    }
  });
  return newObj;
};
export const formatCurrency = (
  money: number | string,
  isFull = true,
): string => {
  return money
    ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') +
        `${isFull ? 'đ' : ''}`
    : `${money}`;
};
export const getDiscountPercent = (
  finalPrice: number,
  oldPrice: number,
): number => {
  let discount = 0;
  if (finalPrice && oldPrice) {
    discount = 100 - Math.round((finalPrice * 100) / oldPrice);
  }
  return discount;
};
export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  return (dateStr =
    ('00' + date.getHours()).slice(-2) +
    ':' +
    ('00' + date.getMinutes()).slice(-2) +
    ':' +
    ('00' + date.getSeconds()).slice(-2) +
    ' ' +
    ('00' + date.getDate()).slice(-2) +
    '/' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '/' +
    date.getFullYear());
};
export const getInvalidGrandTotalErrorMessage = (
  code: string,
  phone: string,
  min: number | null,
  max: number | null,
): string => {
  let message = t(
    'Có lỗi xảy ra. Vui lòng thử lại hoặc liên hệ hotline CSKH: {{phone}}.',
    { phone: phone },
  );
  if (!min && max)
    message = t(
      'Mã giảm giá {{code}} chỉ áp dụng cho đơn hàng có giá trị tối đa {{var0}}. Vui lòng kiểm tra lại giá trị đơn hàng.',
      { code: code, var0: formatCurrency(max) },
    );
  else if (min && !max)
    message = t(
      'Mã giảm giá {{code}} chỉ áp dụng cho đơn hàng có giá trị từ {{var0}} trở lên. Vui lòng kiểm tra lại giá trị đơn hàng.',
      { code: code, var0: formatCurrency(min) },
    );
  else if (min && max)
    message = t(
      'Mã giảm giá {{code}} chỉ áp dụng cho đơn hàng có giá trị từ {{var0}} đến {{formatCurrency(max)}}. Vui lòng kiểm tra lại giá trị đơn hàng.',
      {
        code: code,
        var0: formatCurrency(min),
        'formatCurrency(max)': formatCurrency(max),
      },
    );
  return message;
};
export const getPromotionErrorMessage = (
  params: ErrorCouponType,
): ErrorMessageType => {
  const result: ErrorMessageType = {
    message: '',
    action: null,
  };
  switch (params.errorCode) {
    case 'get_promotion_coupon_not_exist':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> không tồn tại hoặc không hợp lệ.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_inactive':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> đã không còn hiệu lực.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_invalid_or_has_been_used':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> không hợp lệ hoặc đã được sử dụng.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_has_been_used':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> đã được sử dụng.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_invalid':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> không hợp lệ.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_budget_inactive':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> đã không còn hiệu lực.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_out_of_budget':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> đã hết số lượng sử dụng.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_coupon_out_of_stock':
      result.message = t(
        'Xin lỗi! Mã <span>{{ParamsCouponCode}}</span> đã hết số lượng sử dụng.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
    case 'get_promotion_invalid_grand_total':
      result.message = getInvalidGrandTotalErrorMessage(
        params.couponCode,
        params.phone,
        params.orderValueMin,
        params.orderValueMax,
      );
      break;
    default:
      result.message = t(
        'Có lỗi xảy ra khi áp dụng mã <span>{{ParamsCouponCode}}</span> cho đơn hàng này. Xin vui lòng kiểm tra lại sau.',
        { ParamsCouponCode: params.couponCode },
      );
      break;
  }
  return result;
};
export const getCreateOrderErrorMessage = (
  code: string,
  phone: string,
): ErrorMessageType => {
  const result: ErrorMessageType = {
    message: '',
    action: null,
  };
  switch (code) {
    case 'order_promotion_invalid_price':
      result.message = t('common.0');
      result.action = 'back_to_cart';
      break;
    case 'flash_sale_out_of_stock':
      result.message = t('common.1');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_flash_sale_inactive':
      result.message = t('common.2');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_promotion_inactive':
      result.message = t('common.3');
      result.action = 'back_to_cart';
      break;
    case 'coupon_used_or_out_of_budget':
      result.message = t('common.4');
      result.action = 'back_to_cart';
      break;
    case 'get_promotion_coupon_not_exist':
      result.message = t('common.5');
      result.action = 'back_to_cart';
      break;
    case 'get_promotion_coupon_inactive':
      result.message = t('common.6');
      result.action = 'back_to_cart';
      break;
    case 'get_promotion_coupon_invalid_or_has_been_used':
      result.message = t('common.7');
      result.action = 'back_to_cart';
      break;
    case 'budget_out_of_budget':
      result.message = t('common.8');
      result.action = 'back_to_cart';
      break;
    case 'budget_out_of_budget_item':
      result.message = t('common.9');
      result.action = 'back_to_cart';
      break;
    case 'budget_out_of_budget_money':
      result.message = t('common.10');
      result.action = 'back_to_cart';
      break;
    case 'budget_inactive':
      result.message = t('common.11');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_coupon_used':
      result.message = t('common.12');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_invalid_promotion_payment_method':
      result.message = t('common.13');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_invalid_promotion_sku':
      result.message = t('common.14');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_out_of_budget_item':
      result.message = t('common.15');
      result.action = 'back_to_cart';
      break;
    case 'order_promotion_out_of_budget_money':
      result.message = t('common.16');
      result.action = 'back_to_cart';
      break;
    case 'voucher_remain_voucher_not_enough':
      result.message = t('common.17');
      result.action = 'back_to_cart';
      break;
    case 'payment_error':
      result.message = t(
        'Có lỗi xảy ra trong quá trình thanh toán. Vui lòng thử lại hoặc liên hệ hotline CSKH: {{phone}}.',
        { phone: phone },
      );
      result.action = 'back_to_cart';
      break;
    case 'order_already_paid':
      result.message = `Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!`;
      result.action = 'back_to_cart';
      break;
    case 'order_already_canceled':
      result.message = `Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!`;
      result.action = 'back_to_cart';
      break;
    default:
      result.message = t(
        'Có lỗi xảy ra trong quá trình tạo đơn. Vui lòng thử lại hoặc liên hệ hotline CSKH: {{phone}}.',
        { phone: phone },
      );
      result.action = 'try_again';
      break;
  }
  return result;
};
export const isLicenseCart = (orderLines: any): boolean => {
  return orderLines.filter((orderLine: any) => orderLine.isLicense).length > 0;
};
export function keyMirror(keys: string[]): KeyValuePair {
  const map: KeyValuePair = {};
  for (let i = 0; i < keys.length; i++) {
    map[keys[i]] = keys[i];
  }
  return map;
}

export const tsToDate = (ts: string): Date => {
  return new Date(parseInt(ts) * 1000);
};
export const getFullAddress = (address: any) => {
  if (!address) return '';
  return [
    address?.address,
    address?.wardName,
    address?.districtName,
    address?.provinceName,
  ].join(', ');
};
export const cookCategory = (item: MenuItem): CustomCategoryProps => {
  let link: LinkProps = null;
  if (item.urlType === 'rewrite') {
    const blockPageUrl = computeBlockPageUrl(item);
    if (blockPageUrl) link = blockPageUrl;
    else {
      link = {
        href: '/search?router=productListing&' + item.targetPath,
      };
    }
  } else {
    link = {
      href: item.targetPath,
    };
  }
  return {
    id: item.id.toString(),
    name: item.name,
    imgUrl: item.icon,
    link: link,
  };
};
export const fetcher = (url: string) => fetch(url).then((r) => r.json());
export const saveRecentlyProduct = (sku: string, localKey: string): void => {
  const historyStorage = localStorage.getItem(localKey);
  if (!historyStorage) {
    localStorage.setItem(localKey, JSON.stringify([sku]));
    return;
  }
  let histories = JSON.parse(historyStorage);
  histories = histories.filter((item: string) => item !== sku);
  histories = [sku, ...histories];
  if (histories.length > 20) {
    histories.pop();
  }
  localStorage.setItem(localKey, JSON.stringify(histories));
};
export const getExpectedDate = (dateString: string, isMs = false): string => {
  if (!dateString) {
    return '';
  }
  const date = isMs ? tsToDate(dateString) : new Date(dateString);
  const hour = date.getHours();
  return `${
    hour === 8 ? '8:00 - 11:00 ' : hour === 14 ? '14:00 - 18:00 ' : ''
  }${fnsFormat(date, 'dd/MM/yyyy')}`;
};
export const isIOSDevice = () => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return iOS;
};
export const isAndroidDevice = () => {
  const android = /(android)/i.test(navigator.userAgent);
  return android;
};
// Check path visible navigation bottom bar
export const checkPath = (router: NextRouter, path: string): boolean => {
  let pathname = router.asPath || router.pathname;
  pathname === '' ? '/' : pathname;
  const searchParam = pathname.indexOf('?');
  pathname = searchParam >= 0 ? pathname.substring(0, searchParam) : pathname;
  const rawPath =
    path.indexOf('?') >= 0 ? path.substring(0, path.indexOf('?')) : path;
  return pathname === rawPath;
};
// const ticketStatus = [
//   {
//     status: 1,
//     text: 'Tạo mới',
//   },
//   {
//     status: 2,
//     text: 'Chờ xử lý',
//   },
//   {
//     status: 3,
//     text: 'Đang xử lý',
//   },
//   {
//     status: 4,
//     text: 'Đã xử lý',
//   },
// ];
// export interface FeedbackStatus {
//   status: number;
//   text: string;
// }
// export const mapTicketStatus = (status: number): FeedbackStatus => {
//   return ticketStatus.find(
//     (ticketStatus: FeedbackStatus) => ticketStatus.status == status,
//   );
// };
export const checkExpiryDateTimestamp = (
  startDate: string,
  endDate: string,
): boolean => {
  const today = new Date().getTime();
  if (
    today - new Date(parseInt(startDate) * 1000).getTime() > 0 &&
    new Date(parseInt(endDate) * 1000).getTime() - today > 0
  )
    return true;
  return false;
};
export const getRemainingTime = (endDate: string | number): string => {
  const remainingTime =
    (new Date(endDate).valueOf() - new Date().valueOf()) / 86400000;
  if (remainingTime < 6 && remainingTime >= 0) {
    if (remainingTime >= 1) {
      return `${Math.floor(remainingTime)} ${t('ngày')}`;
    } else {
      const hours = Math.floor(
        (new Date(endDate).valueOf() - new Date().valueOf()) / 3600000,
      );
      if (hours >= 1) {
        return `${hours} ${t('giờ')}`;
      } else {
        return `1 ${t('giờ')}`;
      }
    }
  }
  return undefined;
};
export const convertUrlParamsToObject = (urlParams: URLSearchParams) => {
  const urlParamsArray = Array.from(urlParams);
  return urlParamsArray.reduce(
    (acc, cur) => ({
      ...acc,
      [cur[0]]: cur[1],
    }),
    {},
  );
};
export const computeBlockPageUrl = (menu: MenuItem): LinkInterface => {
  if (!menu.targetPath || menu.urlType !== 'rewrite') return null;
  const menuConfig = menu.configs;
  const targetFilterParams = convertUrlParamsToObject(
    new URLSearchParams(menu.targetPath),
  );
  // targetPath has only 1 filter config
  if (Object.keys(targetFilterParams)?.length === 1) {
    const filterKey = Object.keys(targetFilterParams)[0];
    const filterValue =
      menuConfig[filterKey]?.length === 1 ? menuConfig[filterKey][0] : null;
    if (!filterValue) return null;
    switch (filterKey) {
      case 'brands':
        return {
          href: {
            pathname: '/brands/[brandId]',
            query: {
              brandId: filterValue,
            },
          },
          target: menu.isTargetBlank ? '_blank' : '_self',
          as: {
            pathname: buildSlugUrl(PageTypeEnum.BRAND, menu.name, filterValue),
          },
          shallow: true,
        };
      case 'masterCategoryIds':
        return {
          href: {
            pathname: '/block-categories/[categoryId]',
            query: {
              categoryId: filterValue,
            },
          },
          target: menu.isTargetBlank ? '_blank' : '_self',
          as: buildSlugUrl(PageTypeEnum.CATEGORY, menu.name, filterValue),
          shallow: true,
        };
      case 'sellerIds':
        return {
          href: {
            pathname: '/sellers/[sellerId]',
            query: {
              sellerId: filterValue,
            },
          },
          target: menu.isTargetBlank ? '_blank' : '_self',
          as: buildSlugUrl(PageTypeEnum.SELLER, menu.name, filterValue),
          shallow: true,
        };
      case 'categories':
        return {
          href: {
            pathname: '/seller-categories/[sellerCategoryId]',
            query: {
              sellerCategoryId: filterValue,
            },
          },
          target: menu.isTargetBlank ? '_blank' : '_self',
          as: `/${slug(menu.name)}-scat.${filterValue}`,
          shallow: true,
        };
      default:
        return null;
    }
  }
  return null;
};
export const isHomepage = (pathname: string): boolean => {
  // Old version
  // return ['', '/'].includes(pathname);
  // This's added for supporting multi-languages
  return !pathname || /^\/(\?lang=[a-zA-Z-]{2,5})?$/.test(pathname);
};
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 3) | 8;
    return v.toString(16);
  });
};
// convert the start date of date range selector to timestamp
export const convertFromTime = (fromTime: string): string => {
  return (+new Date(fromTime) / 1000).toString();
};
// convert the end date of date range selector to timestamp
export const convertToTime = (toTime: string): string => {
  return ((+new Date(toTime) + 24 * 3599 * 1000) / 1000).toString();
};
export const getDateISOString = (date?: Date): string => {
  const MILISECONDS_RATE = 60000;
  const timeZoneOffset = new Date().getTimezoneOffset() * MILISECONDS_RATE;
  return new Date((date ? date.getTime() : Date.now()) - timeZoneOffset)
    .toISOString()
    .substring(0, 16);
};
export const sortData = (sortDir: string, data: any, key: string) => {
  // sort data by record's key
  const sortedData =
    sortDir === 'asc'
      ? data.sort(
          (obj1: any, obj2: any) => parseInt(obj1[key]) - parseInt(obj2[key]),
        )
      : data.sort(
          (obj1: any, obj2: any) => parseInt(obj2[key]) - parseInt(obj1[key]),
        );
  return sortedData;
};
export const getIdFromYoutubeLink = (url: string) => {
  if (!url) return '';
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : '';
};
export const excludeBlockTypeForBlockPageDesk = [
  'MEGA_MENU',
  'WIDE_THICK_BANNER',
  'HORIZONTAL_4_BANNER',
  'VERTICAL_2_BANNER',
];
export const excludeBlockTypeForBlockPageMobile = [
  'POPUP_BANNER_MOBILE',
  'RECENT_SEARCH',
  'LEFT_OFF_ITEMS',
  'LOCATION',
];
export const filterBlockItems = (
  item: DiscoveryItem,
  blockList: DiscoveryBlock[],
): boolean => {
  const matchFormat = item.url.match(/^#\d+$/);
  if (!matchFormat) return false;
  const blockId = item.url.substring(1);
  const block = blockList.find((e) => e.id === blockId);
  if (!block) return false;
  return true;
};
